import AxiosPermisos from "../../axiosPermisos";
import { path } from "./path";

async function getAllActivities(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getAllActivities}/${id}/activities`,
    true,
    "v2",
    data,
    signal
  );
}

async function getAreaActivities(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getAreaActivities}/${id}/with-activities`,
    true,
    "v2",
    data,
    signal
  );
}

async function getEmployees(data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getEmployees}`,
    true,
    "v2",
    data,
    signal
  );
}

async function createActivity(data) {
  return await AxiosPermisos.post(
    `${path.createActivity}`,
    true,
    data,
    "v2"
  );
}

async function editActivity(data, id) {
  return await AxiosPermisos.put(
    `${path.editActivity}/${id}`,
    true,
    data,
    "v2"
  );
}

async function saveIper(data) {
  return await AxiosPermisos.post(
    `${path.saveIper}`,
    true,
    data,
    "v2"
  );
}

async function savePhoto(data, id) {
  return await AxiosPermisos.postSendFile(
    `${path.savePhoto}/${id}/upload-photo`,
    true,
    data,
    "v2"
  );
}

async function updateIper(data, id) {
  return await AxiosPermisos.put(
    `${path.updateIper}/${id}`,
    true,
    data,
    "v2"
  );
}

async function getIper (id, data = {}, signal) {
  return await AxiosPermisos.get(`${path.getIper}/${id}`, true, 'v2', data, signal);
}

async function getDangers () {
  return await AxiosPermisos.get(`${path.getDangers}`, true, 'v2');
}

async function getRisksByDanger (id) {
  return await AxiosPermisos.get(`${path.getRisksByDanger}/${id}/risks`, true, 'v2');
}

async function getKinney () {
  return await AxiosPermisos.get(`${path.getKinney}`, true, 'v2');
}

async function getPositionByArea(id, data = {}, signal) {
  return await AxiosPermisos.get(`${path.getPositionByArea}/${id}/positions`, true, "v2", data, signal);
}

async function getAreaDetail(id, data = {}, signal) {
  return await AxiosPermisos.get(`${path.getAreaDetail}/${id}/details`, true, "v2", data, signal);
}

async function getHistoryIper(id, data = {}, signal) {
  return await AxiosPermisos.get(`${path.getHistoryIper}/${id}/history`, true, "v2", data, signal);
}

function debounce(func, wait) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    const context = this;
    timer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

export {
  debounce,
  getAllActivities,
  createActivity,
  editActivity,
  getDangers,
  getRisksByDanger,
  getKinney,
  getPositionByArea,
  getAreaDetail,
  saveIper,
  updateIper,
  getIper,
  getAreaActivities,
  getEmployees,
  savePhoto,
  getHistoryIper
};
